import React from "react";
import { motion } from "framer-motion";

export type LoaderProps = {
  loading: boolean;
};

export const LoaderComponent = ({ loading }: LoaderProps) => (
  <motion.svg
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    initial={{ opacity: 0 }}
    animate={{ opacity: loading ? 1 : 0 }}
    fill="currentColor"
  >
    <circle cx={6} cy={50} r={6}>
      <animateTransform
        attributeName="transform"
        dur="1s"
        type="translate"
        values="0 15 ; 0 -15; 0 15"
        repeatCount="indefinite"
        begin={0.1}
      />
    </circle>
    <circle cx={30} cy={50} r={6}>
      <animateTransform
        attributeName="transform"
        dur="1s"
        type="translate"
        values="0 10 ; 0 -10; 0 10"
        repeatCount="indefinite"
        begin={0.2}
      />
    </circle>
    <circle cx={54} cy={50} r={6}>
      <animateTransform
        attributeName="transform"
        dur="1s"
        type="translate"
        values="0 5 ; 0 -5; 0 5"
        repeatCount="indefinite"
        begin={0.3}
      />
    </circle>
  </motion.svg>
);

export const Loader = React.memo(LoaderComponent);
